import { render } from "./VideoPlayer.vue?vue&type=template&id=0031bf7e&scoped=true"
import script from "./VideoPlayer.vue?vue&type=script&lang=js"
export * from "./VideoPlayer.vue?vue&type=script&lang=js"

import "./VideoPlayer.vue?vue&type=style&index=0&id=0031bf7e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0031bf7e"

export default script